import { gql } from '@apollo/client';

const STOCK_CAR_FRAGMENT = gql`
  fragment StockCarFragment on StockCar {
    model {
      id {
        code
      }
    }
  }
`;

export const STOCKCAR_DETAILS_QUERY = gql`
  query StockCar($stockCarIdentifier: StockCarIdentifierInput!) {
    stockCar(stockCarIdentifier: $stockCarIdentifier) {
      ...StockCarFragment
    }
  }
  ${STOCK_CAR_FRAGMENT}
`;

export const STOCKCAR_SEARCH_QUERY = gql`
  query stockCarSearch(
    $stockIdentifier: StockIdentifierInput!
    $searchParameter: StockCarSearchParameterInput
  ) {
    stockCarSearch(stockIdentifier: $stockIdentifier, searchParameter: $searchParameter) {
      results {
        cars {
          stockCar {
            ...StockCarFragment
          }
        }
      }
    }
  }
  ${STOCK_CAR_FRAGMENT}
`;
